import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { emailTemplateQueryKeys } from "./emailTemplateQueryKeys";

export const useMutationDeleteEmailTemplate = ({ api }: { api: ApiType }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ emailTemplateId }: { emailTemplateId: number }) =>
      await api.emailTemplateApi.delete(emailTemplateId),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: emailTemplateQueryKeys.all(),
      }),
  });
};
